import { render, staticRenderFns } from "./ParcelShipments.vue?vue&type=template&id=06058a2e"
import script from "./ParcelShipments.vue?vue&type=script&lang=js"
export * from "./ParcelShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports